import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BrainCircuit, Cpu, Users, Store, Satellite } from 'lucide-react';
import Navbar from '../components/Navbar';

export default function AiSolutionsPage() {
  const navigate = useNavigate();

  return (
    <div className="page-wrapper">
      <Navbar />
      <div className="page-content">
        <section className="vision-section">
          <div className="container">
            <div className="vision-content">
              <div className="vision-badge"><BrainCircuit size={14} /> AI SOLUTIONS</div>
              <h2 className="vision-title">
                Building the World's Most Advanced <br />
                <span className="highlight-text">Crop Disease Detection Platform</span>
              </h2>
              <h3 className="vision-title-hi">
                दुनिया का सबसे उन्नत फसल रोग पहचान मंच बना रहे हैं
              </h3>

              <p className="vision-description">
                BoAI is not just another AgriTech app — we are building an outcome-driven diagnosis platform
                that goes beyond identification. Where competitors stop at telling you what's wrong, BoAI delivers
                the complete solution: AI-powered diagnosis, expert consultations, treatment procurement, and
                community-backed knowledge — all in one unified platform.
              </p>

              <p className="vision-description-hi">
                BoAI सिर्फ एक और AgriTech ऐप नहीं है — हम एक परिणाम-आधारित निदान मंच बना रहे हैं
                जो पहचान से आगे जाता है। जहाँ प्रतियोगी केवल समस्या बताते हैं, BoAI पूर्ण समाधान देता है:
                AI निदान, विशेषज्ञ परामर्श, उपचार खरीद, और समुदाय-समर्थित ज्ञान — सब एक मंच पर।
              </p>

              <div className="vision-stats">
                <div className="vision-stat-item">
                  <div className="stat-icon"><Cpu size={28} /></div>
                  <div className="stat-content">
                    <h4>AI Diagnosis</h4>
                    <p>YOLO & TensorFlow powered detection</p>
                    <p className="hindi-small">YOLO और TensorFlow संचालित पहचान</p>
                  </div>
                </div>
                <div className="vision-stat-item">
                  <div className="stat-icon"><Users size={28} /></div>
                  <div className="stat-content">
                    <h4>Expert Connect</h4>
                    <p>Physical + digital farmer consultations</p>
                    <p className="hindi-small">भौतिक + डिजिटल किसान परामर्श</p>
                  </div>
                </div>
                <div className="vision-stat-item">
                  <div className="stat-icon"><Store size={28} /></div>
                  <div className="stat-content">
                    <h4>Agri Commerce</h4>
                    <p>End-to-end product & price discovery</p>
                    <p className="hindi-small">संपूर्ण उत्पाद और मूल्य खोज</p>
                  </div>
                </div>
                <div className="vision-stat-item">
                  <div className="stat-icon"><Satellite size={28} /></div>
                  <div className="stat-content">
                    <h4>Future: HSI & Robotics</h4>
                    <p>Pre-symptomatic disease detection</p>
                    <p className="hindi-small">लक्षण-पूर्व रोग पहचान</p>
                  </div>
                </div>
              </div>

              <div className="vision-commitment">
                <p className="commitment-text">
                  <strong>Our Philosophy:</strong> Agriculture is fundamentally a physical system. We're building
                  the brain first — combining advanced deep learning, hyperspectral imaging research, and real-world
                  farmer data. The autonomous hands (robotics, AI voice agents, Small Language Models for agriculture)
                  come next. This is how we become a global AgriTech leader.
                </p>
                <p className="commitment-text-hi">
                  <strong>हमारा दर्शन:</strong> कृषि मूलतः एक भौतिक प्रणाली है। हम पहले दिमाग बना रहे हैं —
                  उन्नत डीप लर्निंग, हाइपरस्पेक्ट्रल इमेजिंग अनुसंधान और वास्तविक किसान डेटा को मिलाकर।
                  स्वायत्त हाथ (रोबोटिक्स, AI वॉइस एजेंट, कृषि के लिए SLM) अगले कदम हैं।
                </p>
              </div>

              <div className="page-cta-bar">
                <button className="btn-primary" onClick={() => navigate('/auth')}>
                  Experience AI Solutions
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
